module.exports = __webpack_public_path__ + "static/img/26.3421b13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/question/26.png
// module id = fbmI
// module chunks = 1